import RatingInput from './RatingInput';

export default RatingInput;
